import { Route,Routes } from "react-router-dom";
import { Onboarding } from "../../pages";

export const OnboardingLayout = () => {
    return (
        <>
        <Routes>
        <Route path ="/" element = {<Onboarding /> }/>
        </Routes>
    </>
    )
}